import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DMX_CONTROLLERS } from './actionTypes';
import { getDmxControllersSuccess, getDmxControllersError } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* getControllers({ payload: { user } }) {
  try {
    const response = yield call(dmxAPI.getControllers, user.token);
    yield put(getDmxControllersSuccess(response));
  } catch (error) {
    yield put(getDmxControllersError(error));
  }
}

export function* watchGetDmxControllers() {
  yield takeEvery(GET_DMX_CONTROLLERS, getControllers);
}

function* getDmxControllersSaga() {
  yield all([fork(watchGetDmxControllers)]);
}

export default getDmxControllersSaga;
